import dayjs from "dayjs";
import { isEqual } from "lodash";
import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useScheduleUIContext } from "../ScheduleUIContext";
import { ScheduleCalendar } from "./ScheduleCalendar";

const prepareFilter = (queryParams, values, filterActive) => {
  const { selected_date } = values;
  const newQueryParams = { ...queryParams };
  const filter = {
    paramsStartBookingTime: selected_date
      ?.startOf("month")
      .format("YYYY-MM-DD"),
    paramsEndBookingTime: selected_date?.endOf("month").format("YYYY-MM-DD"),
  };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function SchedulePage({ fullscreen, appointment }) {
  const location = useLocation();
  const paramsSelectedDate = location.state?.paramsSelectedDate;
  const [selectedDate, setSelectedDate] = useState(
    () => dayjs(paramsSelectedDate) ?? dayjs()
  );
  const scheduleUIContext = useScheduleUIContext();
  const scheduleUIProps = useMemo(() => {
    return {
      data: scheduleUIContext.data,
      authData: scheduleUIContext.authData,
      queryParams: scheduleUIContext.queryParams,
      isLoadingData: scheduleUIContext.isLoadingData,
      setQueryParams: scheduleUIContext.setQueryParams,
      goToSettingSchedule: scheduleUIContext.goToSettingSchedule,
      goToCancelSchedule: scheduleUIContext.goToCancelSchedule,
      goToCustomerDetail: scheduleUIContext.goToCustomerDetail,
      goToRemoveSchedule: scheduleUIContext.goToRemoveSchedule,
    };
  }, [scheduleUIContext]);

  const { queryParams, setQueryParams } = scheduleUIProps;

  const handleApplyFilter = (values) => {
    const newQueryParams = prepareFilter(queryParams, values);
    if (!isEqual(newQueryParams, queryParams)) {
      setQueryParams(newQueryParams);
    }
  };

  return (
    <section id="calendar">
      <ScheduleCalendar
        fullscreen={fullscreen}
        appointment={appointment}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        handleApplyFilter={handleApplyFilter}
        scheduleUIProps={scheduleUIProps}
      />
    </section>
  );
}
